"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _findIndex2 = _interopRequireDefault(require("lodash/findIndex"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var TimePickerSelect =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TimePickerSelect, _React$Component);

  function TimePickerSelect(props) {
    var _this;

    _classCallCheck(this, TimePickerSelect);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TimePickerSelect).call(this, props));

    _this.handleClickOption = function (option) {
      if (!option.disabled && _this.props.onClick) {
        _this.props.onClick(option.value);
      }
    };

    _this.selectedIndex = -1;
    _this.listRef = _react.default.createRef();
    _this.selectRef = _react.default.createRef();
    return _this;
  }

  _createClass(TimePickerSelect, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.scrollToSelected();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      this.scrollToSelected();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var selectOptions = this.props.selectOptions.map(function (option) {
        var classNames = (0, _classnames.default)(option.value === _this2.props.value ? '-selected' : '', option.disabled ? '-disabled' : '');
        return _react.default.createElement("li", {
          key: option.value,
          className: classNames,
          onClick: function onClick() {
            return _this2.handleClickOption(option);
          }
        }, option.title);
      });

      var clsPrfx = _ThemeManager.default.getVar('classPrefix');

      return _react.default.createElement("div", {
        className: (0, _classnames.default)(this.props.className, "".concat(clsPrfx, "-timepicker-select ").concat(clsPrfx)),
        ref: this.selectRef
      }, _react.default.createElement("ul", {
        ref: this.listRef
      }, selectOptions));
    }
    /**
     * Scroll to currently selected value
     */

  }, {
    key: "scrollToSelected",
    value: function scrollToSelected() {
      if (this.listRef) {
        var _this$props = this.props,
            selectOptions = _this$props.selectOptions,
            value = _this$props.value;
        var index = (0, _findIndex2.default)(selectOptions, function (option) {
          return option.value === value;
        });

        if (index > -1) {
          var selectedOption = this.listRef.current.children[index];
          var parentElement = this.listRef.current.parentElement;
          var visibleHeight = parentElement.clientHeight;
          var optionHeight = selectedOption.clientHeight;
          var centerOffset = visibleHeight / 2 - optionHeight / 2;
          var timePickerSelect = this.selectRef.current;
          timePickerSelect.scrollTop = selectedOption.offsetTop - centerOffset;
        }
      }
    }
    /**
     * Handler for when an option is clicked
     * @param {Object} option - Select option that was clicked
     */

  }]);

  return TimePickerSelect;
}(_react.default.Component);

exports.default = TimePickerSelect;
TimePickerSelect.propTypes = {
  /**
   * className is used to add extra class for adding new style to override default
   */
  className: _propTypes.default.string,

  /**
   * Selectable options to render
   */
  selectOptions: _propTypes.default.array.isRequired,

  /**
   * Selected option value
   */
  value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /**
   * Callback when an option is clicked
   */
  onClick: _propTypes.default.func
};